import React, { useState, useEffect, useRef } from "react";
import classes from "./Header.module.scss";
import logo from "../../../assets/img/Global/logo.png";
import logo_b from "../../../assets/img/Global/logo_b.png";
import arrow from "../../../assets/img/Global/arrow.svg";
import { headerRoutes } from "../../../router/index";
import $ from "jquery";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./Header.scss";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import Cookies from "js-cookie";
import { useSelector, useDispatch } from "react-redux";
import { white, black } from "../../../features/theme/themeSlice";
const Header = () => {
  const blackTheme = useSelector((state) => state.theme.value);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  global.text = t;
  const languages = [
    { value: "ru", label: "Ru" },
    { value: "en", label: "En" },
    { value: "es", label: "Es" },
    { value: "it", label: "It" },
    { value: "de", label: "De" },
    { value: "pl", label: "Pl" },
    { value: "fr", label: "Fr" },
    { value: "ar", label: "Ar" },
    { value: "kor", label: "Kor" },
    { value: "ja", label: "Ja" },
  ];
  const [localA, setLocalA] = useState(false);
  const [burgerA, setBurgerA] = useState(false);

  let location = useLocation();
  const [numNav, setNumNav] = useState(0);
  const [widthFull, setWidthFull] = useState(false);
  const [defaultOption, setDefaultOption] = useState(Cookies.get("i18next"));

  useEffect(() => {
    setDefaultOption(Cookies.get("i18next"));
    if (localStorage.getItem("theme") === "black") {
      $("body").addClass("black");
      $("body").removeClass("white");
      dispatch(black());
    } else {
      $("body").removeClass("black");
      $("body").addClass("white");
      dispatch(white());
    }
  }, []);
  useEffect(() => {
    if (t("lang") === "ar") {
      $("html").attr("dir", "rtl");
      $("body").addClass("ar");
    } else {
      $("html").attr("dir", "");
      $("body").removeClass("ar");
    }
  }, [t("lang")]);

  return (
    <div className={classes.header}>
      <div className={classes.headerBody}>
        <div className="container">
          <div className={classes.headerRow}>
            <div
              className={
                burgerA
                  ? [classes.headerRowLogo, classes.active].join(" ")
                  : classes.headerRowLogo
              }
            >
              <Link to="/">
                <img src={!blackTheme ? logo : logo_b} alt="" />
              </Link>
            </div>

            <div className={classes.headerRowRight}>
              <div
                className={
                  burgerA
                    ? [classes.headerRowCenterWrapper, classes.active].join(" ")
                    : classes.headerRowCenterWrapper
                }
              >
                <div className={classes.headerRowCenter}>
                  <div className={classes.wrap2Over}>
                    <div className={classes.wrap2}>
                      {headerRoutes.map((navI) => {
                        return (
                          <NavLink
                            to={navI.path}
                            className={[
                              classes.headerNavLink,
                              "headerNavLink",
                            ].join(" ")}
                            key={navI.id}
                          >
                            {t(navI.text)}
                          </NavLink>
                        );
                      })}
                      <div
                        className={[
                          classes.headerRowRightLocalization,
                          classes.mob,
                        ].join(" ")}
                        onClick={() => {
                          setLocalA(!localA);
                        }}
                      >
                        <div
                          className={
                            localA
                              ? burgerA
                                ? [
                                    classes.headerRowRightLocalizationTitle,
                                    classes.active,
                                    classes.white,
                                  ].join(" ")
                                : [
                                    classes.headerRowRightLocalizationTitle,
                                    classes.active,
                                  ].join(" ")
                              : burgerA
                              ? [
                                  classes.headerRowRightLocalizationTitle,
                                  classes.white,
                                ].join(" ")
                              : classes.headerRowRightLocalizationTitle
                          }
                        >
                          {defaultOption}
                          <img src={arrow} alt="" />
                        </div>
                        <div
                          className={
                            localA
                              ? [
                                  classes.headerRowRightLocalizationItems,
                                  classes.active,
                                ].join(" ")
                              : classes.headerRowRightLocalizationItems
                          }
                        >
                          {languages.map((i) => {
                            return (
                              <p
                                key={i.value}
                                onClick={() => {
                                  i18n.changeLanguage(i.value);
                                  setDefaultOption(i.value);
                                }}
                              >
                                {i.value}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classes.headerRowRightLocalization}
                onClick={() => {
                  setLocalA(!localA);
                }}
              >
                <div
                  className={
                    localA
                      ? burgerA
                        ? [
                            classes.headerRowRightLocalizationTitle,
                            classes.active,
                            classes.white,
                          ].join(" ")
                        : [
                            classes.headerRowRightLocalizationTitle,
                            classes.active,
                          ].join(" ")
                      : burgerA
                      ? [
                          classes.headerRowRightLocalizationTitle,
                          classes.white,
                        ].join(" ")
                      : classes.headerRowRightLocalizationTitle
                  }
                >
                  {defaultOption}
                  <img src={arrow} alt="" />
                </div>
                <div
                  className={
                    localA
                      ? [
                          classes.headerRowRightLocalizationItems,
                          classes.active,
                        ].join(" ")
                      : classes.headerRowRightLocalizationItems
                  }
                >
                  {languages.map((i) => {
                    return (
                      <p
                        key={i.value}
                        onClick={() => {
                          i18n.changeLanguage(i.value);
                          setDefaultOption(i.value);
                        }}
                      >
                        {i.value}
                      </p>
                    );
                  })}
                </div>
              </div>

              <a href="https://user.styx-trade.co/login" className={classes.headerRowRightSignBtn}>
                {t("header_login")}
              </a>
              <div
                className="switcher1"
                onClick={() => {
                  if ($("body").hasClass("black")) {
                    $("body").removeClass("black");
                    $("body").addClass("white");
                    localStorage.setItem("theme", "");

                    dispatch(white());
                  } else {
                    $("body").removeClass("white");
                    $("body").addClass("black");
                    localStorage.setItem("theme", "black");
                    dispatch(black());
                  }
                }}
              >
                <div className="switcher1Left">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5333 8C12.5333 8.89661 12.2675 9.77308 11.7693 10.5186C11.2712 11.2641 10.5632 11.8451 9.73483 12.1883C8.90647 12.5314 7.99497 12.6211 7.11559 12.4462C6.23621 12.2713 5.42845 11.8395 4.79445 11.2056C4.16045 10.5716 3.72869 9.76379 3.55377 8.88441C3.37885 8.00503 3.46863 7.09353 3.81175 6.26517C4.15486 5.43681 4.73591 4.7288 5.48142 4.23067C6.22692 3.73254 7.10339 3.46667 8 3.46667C9.20177 3.46843 10.3538 3.94661 11.2036 4.7964C12.0534 5.64618 12.5316 6.79823 12.5333 8ZM8 2.4C8.14145 2.4 8.27711 2.34381 8.37712 2.24379C8.47714 2.14377 8.53333 2.00812 8.53333 1.86667V0.533333C8.53333 0.391885 8.47714 0.256229 8.37712 0.15621C8.27711 0.0561903 8.14145 0 8 0C7.85855 0 7.7229 0.0561903 7.62288 0.15621C7.52286 0.256229 7.46667 0.391885 7.46667 0.533333V1.86667C7.46667 2.00812 7.52286 2.14377 7.62288 2.24379C7.7229 2.34381 7.85855 2.4 8 2.4ZM3.28667 4.04C3.38749 4.13814 3.52263 4.19306 3.66333 4.19306C3.80403 4.19306 3.93918 4.13814 4.04 4.04C4.13974 3.94002 4.19575 3.80456 4.19575 3.66333C4.19575 3.52211 4.13974 3.38665 4.04 3.28667L3.1 2.34C3.05218 2.28173 2.99269 2.23413 2.92536 2.20024C2.85804 2.16635 2.78436 2.14693 2.70907 2.14323C2.63379 2.13954 2.55856 2.15164 2.48824 2.17877C2.41791 2.2059 2.35404 2.24745 2.30075 2.30075C2.24745 2.35404 2.2059 2.41791 2.17877 2.48824C2.15164 2.55856 2.13954 2.63379 2.14323 2.70907C2.14693 2.78436 2.16635 2.85804 2.20024 2.92536C2.23413 2.99269 2.28173 3.05218 2.34 3.1L3.28667 4.04ZM2.4 8C2.4 7.85855 2.34381 7.7229 2.24379 7.62288C2.14377 7.52286 2.00812 7.46667 1.86667 7.46667H0.533333C0.391885 7.46667 0.256229 7.52286 0.15621 7.62288C0.0561903 7.7229 0 7.85855 0 8C0 8.14145 0.0561903 8.27711 0.15621 8.37712C0.256229 8.47714 0.391885 8.53333 0.533333 8.53333H1.86667C2.00812 8.53333 2.14377 8.47714 2.24379 8.37712C2.34381 8.27711 2.4 8.14145 2.4 8ZM3.28667 11.96L2.34 12.9C2.23985 13.0011 2.18367 13.1377 2.18367 13.28C2.18367 13.4223 2.23985 13.5589 2.34 13.66C2.44311 13.7567 2.57864 13.8114 2.72 13.8133C2.86162 13.8127 2.99762 13.7579 3.1 13.66L4.04 12.7133C4.13193 12.6119 4.18132 12.479 4.17795 12.3421C4.17458 12.2052 4.1187 12.0749 4.0219 11.9781C3.92509 11.8813 3.79477 11.8254 3.6579 11.8221C3.52104 11.8187 3.38812 11.8681 3.28667 11.96ZM8 13.6C7.85855 13.6 7.7229 13.6562 7.62288 13.7562C7.52286 13.8562 7.46667 13.9919 7.46667 14.1333V15.4667C7.46667 15.6081 7.52286 15.7438 7.62288 15.8438C7.7229 15.9438 7.85855 16 8 16C8.14145 16 8.27711 15.9438 8.37712 15.8438C8.47714 15.7438 8.53333 15.6081 8.53333 15.4667V14.1333C8.53333 13.9919 8.47714 13.8562 8.37712 13.7562C8.27711 13.6562 8.14145 13.6 8 13.6ZM12.7133 11.96C12.6119 11.8681 12.479 11.8187 12.3421 11.8221C12.2052 11.8254 12.0749 11.8813 11.9781 11.9781C11.8813 12.0749 11.8254 12.2052 11.8221 12.3421C11.8187 12.479 11.8681 12.6119 11.96 12.7133L12.9 13.66C13.0024 13.7579 13.1384 13.8127 13.28 13.8133C13.4214 13.8114 13.5569 13.7567 13.66 13.66C13.7602 13.5589 13.8163 13.4223 13.8163 13.28C13.8163 13.1377 13.7602 13.0011 13.66 12.9L12.7133 11.96ZM15.4667 7.46667H14.1333C13.9919 7.46667 13.8562 7.52286 13.7562 7.62288C13.6562 7.7229 13.6 7.85855 13.6 8C13.6 8.14145 13.6562 8.27711 13.7562 8.37712C13.8562 8.47714 13.9919 8.53333 14.1333 8.53333H15.4667C15.6081 8.53333 15.7438 8.47714 15.8438 8.37712C15.9438 8.27711 16 8.14145 16 8C16 7.85855 15.9438 7.7229 15.8438 7.62288C15.7438 7.52286 15.6081 7.46667 15.4667 7.46667ZM12.34 4.19333C12.4093 4.19395 12.478 4.1807 12.5422 4.15436C12.6063 4.12803 12.6645 4.08915 12.7133 4.04L13.66 3.1C13.745 2.99638 13.7885 2.86482 13.7819 2.73093C13.7754 2.59703 13.7192 2.47037 13.6244 2.37558C13.5296 2.28079 13.403 2.22464 13.2691 2.21807C13.1352 2.21149 13.0036 2.25495 12.9 2.34L11.96 3.28667C11.8603 3.38665 11.8042 3.52211 11.8042 3.66333C11.8042 3.80456 11.8603 3.94002 11.96 4.04C12.0097 4.08996 12.0689 4.12932 12.1343 4.15568C12.1996 4.18203 12.2696 4.19485 12.34 4.19333Z"
                      fill="#EB0158"
                    />
                  </svg>
                </div>
                <div className="switcher1Right">
                  <svg
                    width="11"
                    height="16"
                    viewBox="0 0 11 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.4 9.9942e-06C1.58585 -0.00128273 0.776358 0.122839 0 0.36801C1.62433 0.878476 3.04343 1.89387 4.05087 3.26649C5.05831 4.63911 5.60154 6.29735 5.60154 8C5.60154 9.70266 5.05831 11.3609 4.05087 12.7335C3.04343 14.1061 1.62433 15.1215 0 15.632C1.10005 15.9777 2.26183 16.0815 3.40574 15.9363C4.54965 15.7911 5.64866 15.4004 6.62746 14.7908C7.60627 14.1813 8.44174 13.3673 9.07662 12.4048C9.71151 11.4422 10.1308 10.3538 10.3058 9.21403C10.4808 8.07429 10.4073 6.9102 10.0904 5.80151C9.77355 4.69281 9.22074 3.66573 8.46987 2.79061C7.71901 1.9155 6.78784 1.21305 5.74017 0.731387C4.6925 0.249723 3.55309 0.000233065 2.4 9.9942e-06Z"
                      fill="#2E2E2E"
                    />
                  </svg>
                </div>
              </div>
              <div
                className={
                  burgerA
                    ? [classes.headerRowRightBurger, classes.active].join(" ")
                    : classes.headerRowRightBurger
                }
                onClick={() => {
                  setBurgerA(!burgerA);
                }}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
